<template>
  <div class="ws-dot-status">
    <span class="ws-dot-status__indicator" :class="[`ws-dot-status__indicator_type_${type}`]"></span>
  </div>
</template>

<script>
export default {
  name: 'WsDotStatus',
  props: {
    type: {
      type: String
    }
  }
}
</script>

<style lang="scss">
  .ws-dot-status {
    display: inline-flex;
    align-items: center;
    padding: 4px;
    &__indicator {
      display: block;
      width: 8px;
      height: 8px;
      background: #000;
      border-radius: 100%;
      &_type_success {
        background-color: #3f842f;
      }
      &_type_danger {
        background-color: #EB5757;
      }
    }

  }
</style>
